// redux actions
export const UPDATE_ORDER_ID = "UPDATE_ORDER_ID";
export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";